var map = {
	"./ConfiguratorPageImages/customer-confidence.png": "b678",
	"./ConfiguratorPageImages/left-circles-png.png": "018c7",
	"./ConfiguratorPageImages/right-circles-png.png": "8816",
	"./ConfiguratorPageImages/silent-opus.png": "1f7c",
	"./ConfiguratorPageImages/taylor-you.png": "6153",
	"./ConfiguratorPageImages/vera-wang.png": "cedd",
	"./HomePageImages/Vector 8.png": "1d18",
	"./HomePageImages/industries-block/architecture.png": "0c99",
	"./HomePageImages/industries-block/clothing.png": "843d",
	"./HomePageImages/industries-block/consumer_electronics.png": "9c74",
	"./HomePageImages/industries-block/furniture.png": "d692",
	"./HomePageImages/industries-block/hand_bags.png": "4a01",
	"./HomePageImages/industries-block/sunglasses.png": "e64d",
	"./HomePageImages/industries-block/transportation.png": "f1d6",
	"./HomePageImages/industries-block/watches.png": "3f66",
	"./HomePageImages/main-block-specs-preview.png": "2dab",
	"./HomePageImages/photography-block/1.png": "7173",
	"./HomePageImages/photography-block/10.png": "ff50",
	"./HomePageImages/photography-block/2.png": "b9e1",
	"./HomePageImages/photography-block/3.png": "6a31",
	"./HomePageImages/photography-block/3_1.png": "7119",
	"./HomePageImages/photography-block/4.png": "0772",
	"./HomePageImages/photography-block/5.png": "df21",
	"./HomePageImages/photography-block/6.png": "c764",
	"./HomePageImages/photography-block/7.png": "0eb1",
	"./HomePageImages/photography-block/8.png": "b8ef",
	"./HomePageImages/photography-block/9.png": "b2e3",
	"./VisualsPageImages/1.png": "53f0",
	"./VisualsPageImages/10.png": "fd4e",
	"./VisualsPageImages/11.png": "4f08",
	"./VisualsPageImages/12.png": "4e4d",
	"./VisualsPageImages/13.png": "812d",
	"./VisualsPageImages/2.png": "1842",
	"./VisualsPageImages/3.png": "3d97",
	"./VisualsPageImages/4.png": "62d2",
	"./VisualsPageImages/5.png": "e78d",
	"./VisualsPageImages/6.png": "af3a",
	"./VisualsPageImages/7.png": "913b",
	"./VisualsPageImages/8.png": "880f",
	"./VisualsPageImages/9.png": "b1f9",
	"./VisualsPageImages/closeups.png": "9c42",
	"./VisualsPageImages/engraving.png": "00d9",
	"./VisualsPageImages/mood-setting.png": "fa33",
	"./VisualsPageImages/quince.png": "be81",
	"./VisualsPageImages/reeds.png": "afa1",
	"./VisualsPageImages/right-circles-png.png": "80f1",
	"./VisualsPageImages/vera-wang.png": "f2d1",
	"./blog/head-img.png": "7d21",
	"./icons/ic-canvas-comment-hover.png": "ab10",
	"./icons/ic-canvas-comment-hover2.png": "41f7",
	"./icons/ic-canvas-comment.png": "f5e9",
	"./icons/ic-comment-orange.png": "ac06",
	"./img/3d-example.png": "4450",
	"./img/admin-is-working.png": "055c",
	"./img/client-in-progress.png": "df38",
	"./img/client-model-approved.png": "5ebe",
	"./img/configurator-tooltip.png": "b042",
	"./img/cursor-grater.png": "5a04",
	"./img/designer-is-working.png": "9165",
	"./img/login_demo_mobile.png": "4d8b",
	"./img/login_demo_pc.png": "0776",
	"./img/model-is-approved.png": "dffa",
	"./img/upload/up-3d.png": "c1f2",
	"./img/upload/up-noimg.png": "0f42",
	"./img/upload/up-others.png": "9ae1",
	"./img/upload/up-reference.png": "943e",
	"./img/upload/up-sketch.png": "eeff",
	"./metals/10KR.png": "7b13",
	"./metals/10KW.png": "fbbe",
	"./metals/10KY.png": "9e7f",
	"./metals/14KR.png": "24b6",
	"./metals/14KW.png": "3f73",
	"./metals/14KY.png": "ed85",
	"./metals/18KR.png": "b749",
	"./metals/18KW.png": "fff3",
	"./metals/18KY.png": "4373",
	"./metals/SS.png": "d60b",
	"./stones/A.png": "7793",
	"./stones/AM.png": "9430",
	"./stones/BlackDiamond.png": "388a",
	"./stones/CA.png": "762a",
	"./stones/CT.png": "f9c5",
	"./stones/DIA.png": "97db",
	"./stones/EM.png": "694d",
	"./stones/GA.png": "d925",
	"./stones/OP.png": "57b1",
	"./stones/Onyx.png": "d6aa",
	"./stones/PK.png": "3348",
	"./stones/PT.png": "d18d",
	"./stones/Pearl.png": "aadd",
	"./stones/Peridot.png": "b603",
	"./stones/R.png": "6fb2",
	"./stones/S.png": "304f",
	"./stones/Turquoise.png": "d0c6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b196";